<template>
  <a class="flex justify-end" :href="url" @click.prevent="openNewTab">
    <span
      class="ti ti-question-mark bg-white text-blue-300 font-bold rounded-md p-1 cursor-pointer ring-blue-200 ring-2 hover-info"
    ></span>
  </a>
</template>
<script>
export default {
  name: "InfoButton",
  props: {
    url: {
      type: String,
      default: "#",
    },
  },
  methods: {
    openNewTab() {
      window.open(this.url, "_blank").focus();
    },
  },
};
</script>
<style>
.hover-info {
  transition: transform 0.3s ease, background-color 0.3s ease;

  /* Initial animation: subtle pulsing */
  animation: pulse 1s infinite alternate;
}
.hover-info:hover {
  color: white;
  background-color: rgba(147, 197, 253, 1) !important;
}
/* Keyframe animation for the subtle pulse effect */
@keyframes pulse {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.2);
  }
}
</style>
